import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-wo_008",
  "use": "icon-wo_008-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-wo_008\"><defs><style>#icon-wo_008 .cls-1{fill:none;opacity:0;}</style></defs><g id=\"icon-wo_008_レイヤー_2\" data-name=\"レイヤー 2\"><g id=\"icon-wo_008_icon\"><rect class=\"cls-1\" width=\"24\" height=\"24\" /><rect class=\"cls-2\" x=\"4.91\" y=\"7.42\" width=\"17.68\" height=\"5.66\" transform=\"translate(-3.22 12.72) rotate(-45)\" /><polygon class=\"cls-2\" points=\"2 22 8 20 4 16 2 22\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol